module.exports = __webpack_public_path__ + "img/scientific-notebook_B09HG6HWB5.5dc7b826.jpg";